// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__do-Yz","nudge":"styles_nudge__T8FvF","container":"styles_container__Bz8Ts","text":"styles_text__-Ir3F","menuBackground":"styles_menuBackground__2NRda"};